import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetSalesOpportunityList($input: SalesPipelineListInput!) {
    salesPipeline {
      list(input: $input) {
        __typename
        ... on SalesPipelineListSuccess {
          salesPipelines {
            id
            code
            productId
            companyId
            status
            quoteDate
            saleDate
            createdOn
            updatedOn
            billingLocation {
              locationId
              name
            }
            company {
              companyId
              name
            }
            createdByUser {
              ...UserBaseFields
            }
            product {
              productId
              publicId
              externalSystemId
              computedProductStatus
              chemicalName
              companyProductDescription
            }
            latestQuote {
              priceChangeSubmissionId
            }
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on SalesPipelineListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetSalesOpportunityCustomerCompanies($input: CompanyListInput!) {
    company {
      list(input: $input) {
        __typename
        ... on CompanyListSuccess {
          companies {
            companyId
            name
          }
        }
        ... on CompanyListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
